"use client";
import { createElement, FC } from "react";
import { useImageComponent } from "../../lib/context/config/context";

const Image: FC<{
  src: string;
  width: string;
  height: string;
  alt: string;
  className?: string;
}> = (props) => createElement(useImageComponent(), props);

export default Image;
